"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxEstimateType = exports.TaxFilingCode = exports.TaxQuarter = exports.TaxRegion = exports.TaxPeriod = void 0;
var TaxPeriod;
(function (TaxPeriod) {
    TaxPeriod["AnnualProjected"] = "ANNUAL_PROJECTED";
    TaxPeriod["YearToDate"] = "YTD";
})(TaxPeriod = exports.TaxPeriod || (exports.TaxPeriod = {}));
var TaxRegion;
(function (TaxRegion) {
    TaxRegion["federal"] = "FEDERAL";
    TaxRegion["state"] = "STATE";
})(TaxRegion = exports.TaxRegion || (exports.TaxRegion = {}));
var TaxQuarter;
(function (TaxQuarter) {
    TaxQuarter["q1"] = "Q1";
    TaxQuarter["q2"] = "Q2";
    TaxQuarter["q3"] = "Q3";
    TaxQuarter["q4"] = "Q4";
})(TaxQuarter = exports.TaxQuarter || (exports.TaxQuarter = {}));
var TaxFilingCode;
(function (TaxFilingCode) {
    TaxFilingCode["Single"] = "S";
    TaxFilingCode["Married"] = "M";
    TaxFilingCode["HeadOfHousehold"] = "F";
    TaxFilingCode["MarriedFilingSeparately"] = "MS";
    TaxFilingCode["QualifiedWidower"] = "QW";
})(TaxFilingCode = exports.TaxFilingCode || (exports.TaxFilingCode = {}));
var TaxEstimateType;
(function (TaxEstimateType) {
    TaxEstimateType["Real"] = "Real";
    TaxEstimateType["Estimate"] = "Estimate";
    TaxEstimateType["Base"] = "Base";
})(TaxEstimateType = exports.TaxEstimateType || (exports.TaxEstimateType = {}));
//# sourceMappingURL=taxEstimate.js.map